/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.querySelectorAll("form.resources-search-block-form").forEach(el => {
	const zipInput = el.querySelector("input.resources-search-block-input");
	zipInput.addEventListener("input", e => {
		let zip = zipInput.value.replaceAll(/[^0-9]/gi, '');
		if (zipInput.value !== zip) {
			zipInput.value = zip;
		}
	});
	el.addEventListener("submit", e => {
		e.preventDefault();
		let zip = zipInput.value.replaceAll(/[^0-9]/gi, '').substring(0, 5);
		window.open(`https://findhelp.1800childrenks.org/search_results/${zip}?widget=kcsl&ref=URL`, "_blank")
	});
});
